import { apiClient, unwrap } from './client';
import type { ApiSuccess } from '@/types/api';
import type { Category } from '@/types/product';

export const categoriesApi = {
  /** Returns the full category tree (parents with `children` populated). */
  async getTree(): Promise<Category[]> {
    const res = await apiClient.get<ApiSuccess<Category[]>>('/categories');
    return unwrap(res);
  },

  async getBySlug(slug: string): Promise<Category> {
    // The endpoint returns `{ category, products }` — CategoryPage only needs the
    // category record (it fetches products separately via useProducts), and it
    // relies on `category.id` to filter. Unwrap the inner `category` so that id
    // is present; otherwise the categoryId filter is dropped and every category
    // page shows the same global product list.
    const res = await apiClient.get<ApiSuccess<{ category: Category; products: unknown[] }>>(
      `/categories/${encodeURIComponent(slug)}`
    );
    return unwrap(res).category;
  },
};
